import React from 'react';
import { Link } from 'react-router-dom';
import corredorImage from '../assets/images/banner-asuntos.jpg';
import { useAuth } from '../contexts/AuthContext';
import './ContactPortal.scss';

const ContactPortalHome = () => {
  const { user, loadingUser } = useAuth();

  return (
    <div className="contact-portal-home">
      <div className="hero-image">
        <img src={corredorImage} alt="Corredores Viales" />
      </div>

      <div className="hero-content">
        <h1>GIRU</h1>
        <p className="subtitle">Gestion Integral de Relacion de Usuarios</p>

        {!loadingUser && (
          <div className="hero-actions">
            {user ? (
              <Link to="/consultas-y-reclamos" className="btn btn-primary">Ingresar al Sistema</Link>
            ) : (
              <>
                <Link to="/contactos/login" className="btn btn-primary">Login</Link>
                <Link to="/contactos/registrarse" className="btn btn-secondary">Registrarse</Link>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default ContactPortalHome;
